import React, { Fragment, useContext, useState } from 'react';
import { GlobalContext } from '../../context/Provider';
import henceforthApi from '../../utils/henceforthApi';
import Swal from 'sweetalert2';

interface VerifyPickupOtpModalProps {
    show: boolean;
    handleClose: () => void;
    orderId: string;
    onVerifySuccess: () => void;
}

const VerifyPickupOtpModal: React.FC<VerifyPickupOtpModalProps> = ({ show, handleClose, orderId, onVerifySuccess }) => {
    const { language_data, authState } = useContext(GlobalContext);
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    const handleVerifyOtp = async () => {
        if (!otp || otp.length < 4) {
            return Swal.fire({
                icon: 'warning',
                title: `${language_data?.[authState.lang]?.common_invalid_otp}`,
                text: `${language_data?.[authState.lang]?.common_please_enter_valid_otp}`,
                timer: 2000,
                showConfirmButton: false
            });
        }

        setLoading(true);
        try {
            const items = {
                _id: orderId,
                otp: otp,
                language: "ENGLISH"
            };
            
            await henceforthApi.Order.verifyPickupOtp(items);
            
            Swal.fire({
                icon: 'success',
                title: `${language_data?.[authState.lang]?.common_otp} ${language_data?.[authState.lang]?.common_verified}`,
                text: `${language_data?.[authState.lang]?.common_otp_verified_successfully}.`,
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                onVerifySuccess();
                handleClose();
                setOtp('');
            });
        } catch (err: any) {
            console.log(err?.response?.body?.error_description || err?.message || err);
             Swal.fire({
                icon: 'error',
                title: `${language_data?.[authState.lang]?.common_invalid_otp}`,
                text: `${language_data?.[authState.lang]?.common_please_enter_valid_otp}`,
                timer: 2000,
                showConfirmButton: false
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            {show && (
                <div 
                    className="modal fade show d-block" 
                    tabIndex={-1} 
                    role="dialog"
                    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5 className="modal-title fw-bold">
                                    {language_data?.[authState.lang]?.common_verify_pickup_otp}
                                </h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={handleClose}
                                    disabled={loading}
                                ></button>
                            </div>
                            <div className="modal-body py-4">
                                <div className="px-3">
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">
                                            {language_data?.[authState.lang]?.common_enter_otp}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            placeholder={`${language_data?.[authState.lang]?.common_enter_otp}`}
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ''))}
                                            maxLength={6}
                                            disabled={loading}
                                            style={{ fontSize: '24px', letterSpacing: '10px', textAlign: 'center' }}
                                        />
                                        <small className="text-muted d-block mt-2">
                                            {language_data?.[authState.lang]?.common_otp_sent_to_customer}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 justify-content-center pb-4">
                                <button 
                                    className="btn btn-secondary px-4" 
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    {language_data?.[authState.lang]?.common_cancel}
                                </button>
                                <button 
                                    className="btn btn-primary px-4" 
                                    onClick={handleVerifyOtp}
                                    disabled={loading || !otp}
                                >
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    ) : null}
                                    {language_data?.[authState.lang]?.common_verify}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default VerifyPickupOtpModal;
